<template>
	<div v-if="schedule">
		<section-toggle
			:trigger.sync="isOpened"
		>
			<template slot="title">
				<b>Orari</b>
			</template>

			<template slot="content">
				<div v-for="(time, day) in schedule" class="schedule" v-if="isDeliveryDay(day)">
					<span class="day">{{ $t("general." + day) }}: </span> 
					<span class="hours" v-for="(hours, index) in time">
						<span v-if="time.length > 1 && time[index] !== time[index + 1]">{{ hours }}</span>
					</span>
				</div>
			</template>
		</section-toggle>

	</div>
</template>
<script type="text/javascript">

import SectionToggle from '../Parts/SectionToggle'


export default {
	props: {
		schedule: {
			type: Object,
			default () {
				return null
			}
		}
	},

	data () {
		return {
			isOpened: false
		}
	},

	components: {
		SectionToggle
	},

	methods: {
		isDeliveryDay (day) {
			return [
				'tuesday',
				'wednesday',
				'thursday',
				'friday'
			].includes(day)
		},

		toggle () {
			this.isOpened = !this.isOpened
		}
	},


	mounted () {

	}
}
</script>

<style scoped>
.schedule {
	line-height: 1;
}

.day {
	font-weight: bold;
}
.day,
.hours {
	font-size: 12px;
}

.hours {
	display: inline-block;
}

.hours:not(:last-child)::after {
	content: ', ';
	padding-right: 5px;
}


</style>